export const LANDING = "/";
export const HOME = "/home";
export const PHOTOS = "/photos";
export const SIGN_IN = "/sign/in";
export const PASSWORD_FORGET = "/password/forget";
export const SIGN_OUT = "/sign/out";
export const CREATE_ACCOUNT = "/create/account";
